"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const use_query_params_1 = require("use-query-params");
exports.useSearchQuery = () => {
    const [searchQuery, setSearchQuery] = use_query_params_1.useQueryParams({
        page: use_query_params_1.NumberParam,
        query: use_query_params_1.StringParam,
        sort: use_query_params_1.StringParam,
        size: use_query_params_1.NumberParam,
    });
    if (!searchQuery.page) {
        delete searchQuery.page;
    }
    if (!searchQuery.query) {
        delete searchQuery.query;
    }
    if (!searchQuery.sort) {
        delete searchQuery.sort;
    }
    if (!searchQuery.size) {
        delete searchQuery.size;
    }
    return [searchQuery, setSearchQuery];
};
//# sourceMappingURL=searchQuery.js.map